export const PUBLISHED_LIST_PARAMS = {
  limit: 0,
  depth: 1,
  sort: "-createdAt"
};
